import { defineStore } from "pinia";
import { POI_GROUPS, defaultPoiGroups, kindsOfGroups } from "../map/poiVisibility";

// v3: галочка стала просто вкл/выкл (раньше «на любом зуме»), «туалеты» и
// «мусорки» слились в «удобства», «прочее» убрано - старый выбор не переносится.
export const POI_STORAGE_KEY = "eco_poi_layers_v3";

const knownGroupIds = new Set(POI_GROUPS.map((g) => g.id));

const load = (): string[] => {
  try {
    const raw = localStorage.getItem(POI_STORAGE_KEY);
    if (raw == null) return defaultPoiGroups();
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((id) => typeof id === "string" && knownGroupIds.has(id)) : defaultPoiGroups();
  } catch {
    return defaultPoiGroups();
  }
};

// Какие группы POI (см. map/poiVisibility.ts) отмечены в меню «Слои».
// Ничего не выбирали - все группы включены.
// Хранится в localStorage как удобство конкретного браузера, без бэкенда.
export const usePoiLayersStore = defineStore("poiLayers", {
  state: () => ({
    enabledGroups: load(),
  }),
  getters: {
    enabledKinds: (state): Set<string> => kindsOfGroups(state.enabledGroups),
  },
  actions: {
    toggle(groupId: string) {
      if (!knownGroupIds.has(groupId)) return;
      this.enabledGroups = this.enabledGroups.includes(groupId)
        ? this.enabledGroups.filter((id) => id !== groupId)
        : [...this.enabledGroups, groupId];
      try {
        localStorage.setItem(POI_STORAGE_KEY, JSON.stringify(this.enabledGroups));
      } catch {
        /* хранилище недоступно - выбор просто не переживёт перезагрузку */
      }
    },
  },
});
